import { Link } from "react-router-dom"
import { useLocation } from 'react-router-dom';
import {FaFacebookSquare, FaTwitterSquare, FaInstagramSquare} from 'react-icons/fa'
import { useGlobalContext } from "../context";



const links = [
    {
        url:'/',
        text:'Home',
    },
    {
        url:'/menu',
        text:'Menù',
    },
    {
        url:'/contattaci',
        text:'Contattaci',
    },
]

const LinkComponent = ({classStyle})=>{
    const location = useLocation();
    const {closeSidebar} = useGlobalContext();
    return(
        <ul className={classStyle}>
            {
                links.map(link=>{
                    return <Link to={link.url} key={link.text} className={location.pathname === link.url ? " link-actual" : "link-hover"} onClick={closeSidebar}>
                        <h3 className="title">{link.text}</h3>
                        <hr/>
                    </Link>
                })
            }
        </ul>
    )
}

const socialLinks =[
    {
        url: "https://www.facebook.com/ilFlautoMagicoSalaDaTe/",
        icon: <FaFacebookSquare className="social-icon" />,
    },
    {
        url: "http://instagram.com/Ilflauto_magico",
        icon: <FaInstagramSquare className="social-icon" />,
    },
    {
        url: "https://twitter.com/home?lang=it",
        icon: <FaTwitterSquare className="social-icon" />,
    },
]

const SocialComponent = ({classStyle})=>{
    return(
        <ul className={classStyle}>
            {
                socialLinks.map(link=>{
                    return <a href={link.url} key={link.url}>
                        {
                            link.icon
                        }
                    </a>
                })
            }
        </ul>
    )
}

const boxMenu = {
    title: "Keemun (Cina)",
    text: "Tè nero dalle foglie piccole e sottili; conosciuto per il suo sapore di orchidea e per il suo profumo deciso.",
    tags: ["Tè nero", "Cina", "€3.50"],
    button: <Link to="/menu" className="box-button title">Vedi il Menu completo</Link>,
}

const boxContact = {
    title: "Dubbi o consigli?",
    text: "Hai qualche dubbio oppure vuoi consigliarci una nuova ricetta da inserire nel nostro catalogo? Contattaci ad uno dei nostri canali social oppure compila il form nella sezione dedicata!",
    button: <Link to="/contattaci" className="box-button title">Contattaci!</Link>,
}

export {LinkComponent, SocialComponent, boxMenu, boxContact};